import React from 'react';
import CommonWelcomeAdd from '../../../components/Welcome/CommonWelcomeAdd';

const WelcomeOutAdd = () => {
    return (
        <CommonWelcomeAdd
            pageName='Pazarlama > Karşılamalar > Antrepo Tahliye'
            isOut={true}
            isIn={false}
        />
    )
}

export default WelcomeOutAdd;